import { twMerge } from "tailwind-merge";

export function Kbd({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <kbd
      className={twMerge(
        "pointer-events-none inline-flex h-4 select-none items-center rounded-sm border border-current px-1 font-mono text-[11px] font-medium text-current",
        className,
      )}
    >
      {children}
    </kbd>
  );
}
